export const NEWS = [
  {
    date: '18 марта 2025, 13:21',
    version: '',
    text: 'Министр жилищно-коммунального хозяйства Московской области Кирилл Григорьев с делегацией отраслевых специалистов ведомства высоко оценил работу диспетчерского центра АО «Росатом Инфраструктурные решения» в городе Обнинске основанную на Платформе «Цифровое ресурсоснабжение»',
  },
  {
    date: '14 марта 2025, 12:32',
    version: '',
    text: 'Платформа «Цифровое ресурсоснабжение» стала победителем национальной ИТ-премии «Цифровые вершины – 2025» в номинации лучшее ИТ-решение для энергетики',
  },
  {
    date: '7 марта 2025, 10:00',
    version: '',
    text: 'Для продукта «Цифровое ресурсоснабжение» Росатом наладил выпуск собственного оборудования: шкафы управления и диспетчеризации',
  },
  {
    date: '21 февраля 2025, 11:13',
    version: '',
    text: 'Выпущено обновление Платформы, повышающее стабильность ее работы',
  },
  {
    date: '24 января 2025, 17:32',
    version: '',
    text: 'Пользователям мобильного приложения с соответствующими правами модуля «Поддержка эксплуатации» стали доступны «Дефекты» и «Значения работы оборудования» в разделе «Статистика»',
  },
  {
    date: '20 января 2025, 14:10',
    version: '',
    text: 'Пользователям десктоп приложения модуля «Поддержка эксплуатации» стали доступны «Дефектная ведомость» и «Анализ работы оборудования» в разделе «Отчёты»',
  },
  {
    date: '10 января 2025, 16:42',
    version: '',
    text: 'В тестовом режиме пользователям мобильного приложения с соответствующими правами стал доступен модуль «Анализ балансов»',
  },
  {
    date: '16 декабря 2024, 09:18',
    version: '',
    text: 'Выпущено обновление Платформы повышающее быстродействие ее работы',
  },
];
